// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__yEuva","hideMobilePagination":"Pagination_hideMobilePagination__If4vY","dot":"Pagination_dot__Frw5A","dotActive":"Pagination_dotActive__SYM_p"};